// extracted by mini-css-extract-plugin
export default {"dialog-body":"ErrorDialog_dialog-body__hIlLY","errors-holder":"ErrorDialog_errors-holder__IGmzf"};